import React from "react";

import HoverTextOverlay from "core/HoverTextOverlay";

import { SubmissionPhoto } from "./styles";

const SubmissionsGridItemContent = ({ submissionData }) => (
    <>
        <SubmissionPhoto
            src={submissionData.imageSrc}
            alt={submissionData.title}
        />
        <HoverTextOverlay hoverText={submissionData.title} />
    </>
);

export default SubmissionsGridItemContent;
